/* eslint-disable jsx-a11y/no-distracting-elements */
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Contact from "./components/Contact";
import About from "./components/About";
import Error from "./components/Error";
import Facts from "./components/Facts";
// import MainAnimation from "./components/MainAnimation";
import HomePage from "./components/HomePage";
import Highlight from "./components/Highlight";
import Timeline from "./components/Timeline";
import Events from "./components/Events";
import Teams from "./components/Teams";
import Venue from "./components/Venue";
import { Box, ChakraProvider, Heading } from "@chakra-ui/react";
import Timeline2 from "./components/Timeline2";
import Timeline4 from "./components/Timeline4";
import Timeline3 from "./components/Timeline3";
import Lion from "./components/images/lion.gif";
import Banner1 from "./components/Banner1";
import Banner2 from "./components/Banner2";
import Banner3 from "./components/Banner3";
import Banner4 from "./components/Banner4";
import Marquee from "react-fast-marquee";
import TechHeads from "./components/TechHeads";
import FacultyCards from "./components/FacultyCards";
// import CountdownTimer from "./components/CountdownTimer";
// import FacultyCards from './components/FacultyCards';
import Organizers from "./components/Organizers";
import Schedule from "./components/Schedule";

function App() {
  // const THREE_DAYS_IN_MS = new Date("2022-09-27T00:00:00");
  // const dateTimeAfterThreeDays = THREE_DAYS_IN_MS ;

  return (
    <ChakraProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route
            path="/"
            exact
            element={
              <>
                <HomePage />
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                    padding:'10px 0px 25px 0px',
                  }}
                >
                  <Heading
                    textAlign={"center"}
                    padding={"10"}
                    color={"red.500"}
                  >
                    Registrations are over now....Thank you for Participating!!!
                  </Heading>
                  {/* <CountdownTimer targetDate={dateTimeAfterThreeDays} /> */}
                </Box>
                <Venue />
                <Heading textAlign={"center"} padding={"8"} color={"blue.500"}>
                  CORE COMMITTEE
                </Heading>
                <FacultyCards />
                <br/>
                <TechHeads />
                <br />
                <Heading textAlign={"center"} padding={"0"} color={"blue.500"}>
                ORGANIZERS AND CORE TEAM
                </Heading>
                <Organizers />
                <Facts />
                <Marquee
                  speed={80}
                  pauseOnClick={true}
                  gradient={false}
                  style={{
                    position: "sticky",
                    bottom: "0",
                    // top: "0px",
                    color: "Red",
                    fontWeight: "bold",
                    height: "40px",
                    background: "#34F5C5",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    letterSpacing: "3px",
                  }}
                >
                  <img
                    src={Lion}
                    alt="Lion GIF"
                    style={{ width: "80px", display: "inline" }}
                  />
                  &nbsp; **Schedule is now available** &nbsp;
                  <img
                    src={Lion}
                    alt="Lion GIF"
                    style={{ width: "80px", display: "inline" }}
                  />
                </Marquee>
              </>
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/technical"
            element={
              <>
                <Banner2 />
                <Timeline />
              </>
            }
          />
          <Route
            path="/cultural"
            element={
              <>
                <Banner1 />
                <Timeline2 />
              </>
            }
          />
          <Route
            path="/finearts"
            element={
              <>
                <Banner3 />
                <Timeline3 />
              </>
            }
          />
          <Route
            path="/literary"
            element={
              <>
                <Banner4 />
                <Timeline4 />
              </>
            }
          />
          <Route path="/events" element={<Events />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/highlights" element={<Highlight />} />
          <Route path="*" element={<Error />} />
          <Route path="/teams" element={<Teams />}></Route>
        </Routes>
        <br />
        <Footer />
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
